// extracted by mini-css-extract-plugin
module.exports = {"root":"_2A5Ov","button":"_2BVnX","hideCursor":"_378El"};